import { LogIn, ShieldAlert } from 'lucide-react'
import { useEffect, useRef } from 'react'
import { useAuth } from 'react-oidc-context'

import { Button } from '@/components/ui/Button'
import { useAuthStore } from '@/stores/auth-store'

export function SessionExpiredDialog() {
  const { sessionExpired } = useAuthStore()
  const auth = useAuth()
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    const dialog = dialogRef.current
    if (!dialog) return
    if (sessionExpired && !dialog.open) {
      dialog.showModal()
    }
  }, [sessionExpired])

  const handleSignIn = () => {
    const returnUrl = window.location.pathname + window.location.search
    void auth.signinRedirect({ state: { returnUrl } })
  }

  if (!sessionExpired) return null

  return (
    <dialog
      ref={dialogRef}
      onCancel={(e) => {
        e.preventDefault()
      }}
      className="rounded-lg shadow-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 p-0 backdrop:bg-gray-900/60 max-w-sm w-full"
    >
      <div className="p-6 space-y-4">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-amber-100 dark:bg-amber-900/30 rounded-lg">
            <ShieldAlert className="w-6 h-6 text-amber-600 dark:text-amber-400" />
          </div>
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            Session Expired
          </h2>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Your session has ended. Please sign in again to continue. Any unsaved changes will need to
          be re-entered after signing in.
        </p>
        <div className="flex justify-end pt-2">
          <Button onClick={handleSignIn}>
            <LogIn className="w-4 h-4 mr-1.5" />
            Sign In
          </Button>
        </div>
      </div>
    </dialog>
  )
}
